import { IConfig } from '@cian/config/shared';

import { TNewbuildingEntryBannerType } from '../types/newbuildingEntryBanner';

export function getNewbuildingMixedEntryBannerType(config: IConfig): TNewbuildingEntryBannerType | null {
  const bannerType = config.get<string>('frontend-serp.newbuildingEntryMixedBannerType');

  if (!bannerType) {
    return null;
  }

  return bannerType === 'mixed_promo' ? 'mixed_promo' : 'mixed';
}
